import paths from "routes/paths";
import XHTTP from "services/api/xhttp";
import CommonUtils from "services/common/utils";

class AlertPoliciesApi {
  static END_POINTS = {
    alertPolicies: paths.api.alertFactory.alertPolicies,
    manageOutputs: paths.api.alertFactory.manageOutputs,
  };

  static getAlertPolicies(filters) {
    const queryString = CommonUtils.buildQueryStringFromObject(filters);

    return XHTTP(`${this.END_POINTS.alertPolicies}?${queryString}`, {
      method: "get",
    });
  }

  static manageAlertPoliciesOutputs(data) {
    return XHTTP(`${this.END_POINTS.manageOutputs}`, {
      method: "post",
      body: JSON.stringify(data),
    });
  }
}

export default AlertPoliciesApi;
